import { StyledInput } from './CheqHiddenField.styles';
import { CHEQ_HIDDEN_FIELD_ID } from './getCheqHiddenFieldValue';

const CheqHiddenField = () => {
  return (
    <StyledInput
      type="hidden"
      id={CHEQ_HIDDEN_FIELD_ID}
      name={CHEQ_HIDDEN_FIELD_ID}
      formGroupProps={{ label: 'cheq', hideLabel: true }}
    />
  );
};

export default CheqHiddenField;
